// Spend-X-Get-Y functionality based on theme2.0 logic
async function onCartUpdate() {
  const cartRootUrl = window.Shopify.routes.root;
  const spendXGetYPromo = document.getElementById("spend-x-get-y-promo");

  if (!spendXGetYPromo) return;

  const promoData = spendXGetYPromo.dataset.spendxgetypromo;
  if (!promoData || promoData === 'null') return;
  
  const parsedPromoData = JSON.parse(promoData);
  const { variantId } = getProductIds(parsedPromoData.freeProduct);
  const freeProductId = variantId.split("ProductVariant/")[1];

  const shopifyCart = await fetch(`${cartRootUrl}cart.js`, {
    cache: "no-store",
  });
  const cartData = await shopifyCart.json();
  const cartTotal = cartData.items_subtotal_price;

  // Logic to show modal
  if (shouldShowPrompt(parsedPromoData, cartTotal)) {
    await setPromoDataFields(parsedPromoData, cartTotal);
  }

  const freeItemInCart = cartData.items.some((item) => {
    return item.id.toString() === freeProductId;
  });

  if (cartTotal >= parsedPromoData.minimumSpend && !freeItemInCart) {
    const formData = {
      items: [
        {
          id: freeProductId,
          quantity: 1,
        },
      ],
      sections: "cart-items",
    };

    const response = await fetch(`${cartRootUrl}cart/add.js`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });

    await response.text();

    // Update cart display
    const cartSectionId = document.querySelector("[data-cart-section-id]");
    if (cartSectionId) {
      const cartSectionIdValue = cartSectionId.getAttribute(
        "data-cart-section-id"
      );
      const cartItemsResponse = await fetch(
        `${cartRootUrl}cart?${cartSectionIdValue}`
      );
      const cartItemsText = await cartItemsResponse.text();
      const html = new DOMParser().parseFromString(cartItemsText, "text/html");
      const cartItems = document.getElementById("cart-items");
      const newCartItems = html.getElementById("cart-items");
      if (cartItems && newCartItems) {
        cartItems.innerHTML = newCartItems.innerHTML;
      }
    }

    // Also trigger cart update event
    document.dispatchEvent(new CustomEvent("cartUpdated"));
  }
}

async function setPromoDataFields(parsedPromoData, cartTotal) {
  const { variantId, productId } = getProductIds(parsedPromoData.freeProduct);
  const productDetails = await getProductDetails(productId, variantId);
  const formattedCopy = getFormattedCopy(parsedPromoData, cartTotal);

  // Use existing buildModal from free-product system
  if (window.buildModal) {
    window.buildModal({
      price: productDetails.price * 100,
      msrp: productDetails.compareAtPrice * 100,
      productTitle: productDetails.title,
      collection: parsedPromoData.productCollectionUrl,
      copy: formattedCopy,
      image: productDetails.image,
      button: parsedPromoData.promptButtonCopy,
      subtext: parsedPromoData.promptModalSubText,
      disclaimer: parsedPromoData.promptModalDisclaimer,
    });
  }
}

async function getProductDetails(productId, variantId) {
  // Simplified version - in production you'd use GraphQL like theme2.0
  // For now, return mock data or fetch from Storefront API
  try {
    const response = await fetch(`/products/${productId.split("/").pop()}.js`);
    const product = await response.json();
    const variant = product.variants.find(
      (v) => v.id.toString() === variantId.split("/").pop()
    );

    return {
      title: product.title,
      image: product.featured_image,
      price: variant ? variant.price / 100 : product.price / 100,
      compareAtPrice: variant
        ? (variant.compare_at_price || variant.price) / 100
        : product.price / 100,
    };
  } catch (error) {
    console.error("Error fetching product details:", error);
    return {
      title: "Free Product",
      image: "",
      price: 0,
      compareAtPrice: 0,
    };
  }
}

function getProductIds(value) {
  const [variantId, productId] = value.split(",");
  return { variantId, productId };
}

function getFormattedCopy(parsedPromoData, cartTotal) {
  let formattedCopy;
  const copy = parsedPromoData.promptModalCopy;

  if (copy.toLowerCase().includes("$x")) {
    const formattedDistance = formatCurrency(
      parsedPromoData.minimumSpend - cartTotal
    );
    formattedCopy = copy.replace("$x", `$${formattedDistance}`);
  } else {
    formattedCopy = copy;
  }

  return formattedCopy;
}

function shouldShowPrompt(parsedPromoData, cartTotal) {
  return (
    cartTotal < parsedPromoData.minimumSpend &&
    cartTotal > 0 &&
    (!parsedPromoData.distanceFromMinimumSpend ||
      cartTotal >= parsedPromoData.distanceFromMinimumSpend)
  );
}

function formatCurrency(amount) {
  return (amount / 100).toFixed(2);
}

// Initialize spend-x-get-y functionality
function initSpendXGetY() {
  // Run on initial load
  onCartUpdate();

  // Listen for cart update events
  document.addEventListener("cartUpdated", onCartUpdate);

  // Also listen for Shopify cart events if available
  if (window.Shopify && window.Shopify.onCartUpdate) {
    window.Shopify.onCartUpdate = onCartUpdate;
  }
}

// Auto-initialize when DOM is loaded
document.addEventListener("DOMContentLoaded", initSpendXGetY);

// Make functions globally accessible
window.onCartUpdate = onCartUpdate;
window.initSpendXGetY = initSpendXGetY;
